export default function Config(dataset, color) {
  const source = []
  const dimensions = [dataset.dimensions[0]]
  dataset.source.forEach((m) => {
    const index = source.findIndex(n => n[dimensions[0]] === m[0])
    if (index > -1) {
      source[index][m[2]] = m[1]
    } else {
      source.push({ [dimensions[0]]: m[0], [m[2]]: m[1] })
    }
    !dimensions.includes(m[2]) && dimensions.push(m[2])
  })
  const data = {}
  data.source = source.slice(0, 6)
  data.dimensions = dimensions
  const config = {
    color,
    dataset: data,
    // legend: {
    //   top: 'bottom'
    // },
    // tooltip: {
    //   trigger: 'axis',
    //   axisPointer: {
    //     type: 'shadow'
    //   }
    // },
    xAxis: {
      type: 'category',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#666995'
      },
      splitLine: {
        lineStyle: {
          color: '#EFEFF2',
        }
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: false

      },
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false

      },
      splitLine: {
        lineStyle: {
          color: '#EFEFF2',
        }
      }
    },
    grid: {
      containLabel: true,
      top: '6%',
      right: '52',
      bottom: '4%',
      left: '52',
    },
    series:
      data.dimensions.map((m, index) => {
        if (index === 0) {
          return
        }
        return {
          type: 'bar',
          stack: data.dimensions[0],
          // seriesLayoutBy: 'row',
          silent: true,
          barWidth: 30,
        }
      })
  }
  return config
}
